import * as React from "react";

const IconMoney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={41}
    height={40}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M20.103 36.143a.171.171 0 0 1-.205 0l-7.013-5.18a15 15 0 0 1-5.806-9.138l-2.077-10.38a.17.17 0 0 1 .092-.187l14.83-7.414a.168.168 0 0 1 .152 0l14.83 7.414c.068.035.105.111.091.188l-1.692 8.46c.827.27 1.608.64 2.331 1.094l1.813-9.064a2.677 2.677 0 0 0-1.425-2.914l-14.83-7.414a2.688 2.688 0 0 0-2.388 0L3.976 9.022a2.677 2.677 0 0 0-1.424 2.914l2.077 10.382A17.486 17.486 0 0 0 11.4 32.975l7.013 5.18c.475.35 1.03.527 1.587.527.556 0 1.113-.175 1.588-.527l.89-.658c-.589-.59-1.107-1.25-1.546-1.965l-.83.612v-.001Z"
    />
    <path
      fill="url(#b)"
      d="M31.37 31.178c.19.172.286.397.286.676 0 .325-.111.599-.335.816-.223.219-.534.352-.934.398v-2.33c.465.12.792.268.983.44Zm-2.868-3.119c0 .252.085.456.252.614.167.158.469.292.906.405v-2.163c-.362.047-.647.172-.851.377a1.043 1.043 0 0 0-.308.767h.001Zm10.25 1.939a8.75 8.75 0 0 1-8.75 8.75 8.75 8.75 0 0 1-8.75-8.75 8.75 8.75 0 0 1 8.75-8.75 8.75 8.75 0 0 1 8.75 8.75Zm-5.45 1.73c0-.614-.193-1.119-.58-1.514-.385-.396-.987-.682-1.806-.858l-.46-.097v-2.33c.678.111 1.042.511 1.087 1.2h1.66c-.038-.781-.3-1.401-.788-1.862-.487-.461-1.142-.728-1.96-.802v-.934h-.795v.934c-.856.066-1.537.342-2.044.83-.507.489-.76 1.095-.76 1.82 0 .614.2 1.124.6 1.528.4.405 1 .69 1.8.858l.334.07v2.455c-.363-.075-.649-.23-.858-.467-.21-.238-.333-.552-.37-.942h-1.66c.028.837.302 1.51.824 2.023.52.511 1.21.805 2.064.878v.949h.795v-.935c.883-.065 1.59-.353 2.12-.864.53-.51.796-1.157.796-1.939l.002-.001Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={2.5}
        x2={23.392}
        y1={1.328}
        y2={45.374}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.272} stopColor="#34263B" />
        <stop offset={0.658} stopColor="#13172C" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={21.71}
        x2={36.129}
        y1={22.622}
        y2={37.041}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.35} stopColor="#F7052D" />
        <stop offset={0.85} stopColor="#CA5AFA" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconMoney;
